import Head from 'next/head';

// Components
import HowItWork from '@components/pages/cpa/epncpa/BlockHowItWork';
import Header from '@components/pages/cpa/epncpa/Header';
// import BlockOurPartners from '@components/pages/affiliate/BlockOurPartners';
import Advantages from '@components/pages/cpa/epncpa/BlockAdvantages';
import BlockSeo from '@components/pages/cpa/epncpa/BlockSeo';
import Steps from '@components/pages/cpa/epncpa/BlockSteps';

// Helpers
import { companyName } from '@config/globalDomain';
import useI18n from '@i18n';

const AdvertiserPage: React.FC = () => {
    const { t, locale } = useI18n('Cpa');
    const formLink = `/${locale}/cpa/apply`;
    return (
        <>
            <Head>
                <title>{t('ePN - a tool to increase sales', { companyName })}</title>
                <meta
                    name="description"
                    content={t(
                        'Cashback service is the way to modern and effective marketing. Be faster than your competitors!',
                    )}
                />
            </Head>

            <Header formLink={formLink} />
            <HowItWork />
            {/* <BlockOurPartners /> */}
            <Advantages />
            <Steps />
            <BlockSeo />
        </>
    );
};

export default AdvertiserPage;
